module.exports = __webpack_public_path__ + "img/@logo_sejong@3x.c0ef6183.png";